import { Navigation, Pagination } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import SubText from "components/shared/SubText";
import { useSelector } from "react-redux";
import NewPodcastSkeleton from "components/skeleton/NewPodcastSkeleton";
import { Link } from "react-router-dom";
import { RouteName } from "constant/routeNames";
import { lazy, Suspense } from "react";

const Podcastcard = lazy(() => import("./Podcastcard"));

function NewestPodcastCoursel({ podcasts, isLoading }: any) {
  const loggedInUser = useSelector((state: any) => state?.user?.currentUser);

  return (
    <>
      {!isLoading && (
        <Suspense fallback={<NewPodcastSkeleton />}>
          <div className="mb-40">
            {podcasts && (
              <>
                {/* top section */}
                <div className="flex justify-between w-full mt-10 mb-8">
                  <div>
                    <SubText text="New podcasts" className="font-bold" />
                  </div>
                  <Link to={RouteName.SeeAllNewPodcastRoute + "?page=1"}>
                    <p className="font-[500] text-[15px] text-[#F50537] cursor-pointer mr-4">
                      See all
                    </p>
                  </Link>
                </div>
                {/* coursel */}
                <div className="">
                  <Swiper
                    slidesPerView={5}
                    breakpoints={{
                      0: {
                        slidesPerView: 2,
                      },
                      370: {
                        slidesPerView: 2,
                      },
                      700: {
                        slidesPerView: 3,
                      },
                      1100: {
                        slidesPerView: 4,
                      },
                      1200: {
                        slidesPerView: 5,
                      },
                      1500: {
                        slidesPerView: 6,
                      },
                      1600: {
                        slidesPerView: 7,
                      },
                    }}
                    modules={[Pagination, Navigation]}
                    navigation={true}
                    className="mt-4 mb-5 mySwiper"
                  >
                    {podcasts.map((podcast: any, i: number) => (
                      <div key={i}>
                        <SwiperSlide className="">
                          <Podcastcard
                            podcast={podcast}
                            user={loggedInUser}
                            // favorite={favorite}
                          />
                        </SwiperSlide>
                      </div>
                    ))}
                  </Swiper>
                </div>
              </>
            )}
          </div>
        </Suspense>
      )}
      {isLoading && <NewPodcastSkeleton />}
    </>
  );
}

export default NewestPodcastCoursel;
